export default __webpack_public_path__ + "static/media/Pre-worlds-perticipation.1e31b998.webp";